<template>
  <div class="ErrorList">
    <el-dialog
        title=""
        :visible="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        @close="handleClose"
        width="70%"
        center
        style="border-radius: 20px!important;"
    >
      <el-scrollbar style="height: 560px;min-height: 560px">
        <div class="invoice-wrapper" ref="invoiceRef">
          <div class="invoice-box">
            <!-- 标题 -->
            <div class="invoice-header-part">
            <div class="text-center">
              <div class="title">{{ $t('saledFeedback.addTemplate01') }}</div>
            </div>

            <!-- 宛先 / 发行元 -->
            <div class="header-section">
              <div>
                <div class="client-info">{{ info.userName }} <span style="margin: 0 10px;font-size: 18px;">様</span> {{ $t('saledFeedback.addTemplate02') }}</div>
                <div v-if="info.billTopic" class="subject">
                  <span>{{ $t('saledFeedback.addTemplate03') }}：</span>
                  <el-tooltip :content="info.billTopic" placement="top" effect="light">
                      <p class="text-row-2 subject-text">{{ info.billTopic }}</p>
                  </el-tooltip>
                </div>
              </div>
              <div class="sender-info">
                <!-- 下载 -->
                <button style="cursor: pointer;position: absolute;right: 70px;top: -50px;" class="no-print" @click="downloadExcel">Excel ⬇️</button>
                <button style="cursor: pointer;position: absolute;right: 0;top: -50px;" class="no-print" :disabled="isDownloading" @click="downloadPdf">PDF ⬇️</button><br />
                {{ $t('saledFeedback.addTemplate05') }}: {{ info.sendBillDate | dateFormatToSecond }}<br />
                {{ $t('saledFeedback.addTemplate06') }}: {{ info.tradingNo }}<br /><br />
                <strong>{{ $t('saledFeedback.addTemplate07') }}{{ info.companyName }}</strong><br />
                {{ $t('saledFeedback.addTemplate08') }}: {{ info.postCode }}<br />
                {{ $t('fund.address') }}: {{ info.address }}<br />
                TEL: {{ info.contactPhone }}<br />
                {{ $t('saledFeedback.addTemplate09') }}：{{ info.contactPerson }}
              </div>
            </div>

            <!-- 总金额 -->
            <div class="grand-total-box">
              <h2>{{ $t('saledFeedback.addTemplate10') }}</h2>
              <div class="price">
                {{ formatThousands(info.moneyCn) }}<span style="color: #ff8726;font-size: 32px;margin-left: 25px">RMB</span>
                <span style="color: #ff8726;font-size: 32px;margin-left: 20px;">{{ formatThousands(info.moneyJp) }}<span style="color: #ff8726;font-size: 32px;margin-left: 15px;">円</span></span>
              </div>
            </div>
            <div class="ck">&nbsp;円{{$t('saledFeedback.addTemplate25')}}</div>

            <!-- 内译 -->
            <h3 class="section-title">{{ $t('saledFeedback.addTemplate11') }}</h3>
            <table class="summary-table" style="width: 50%">
              <tr v-for="(item, index) in summary" :key="index">
                <th>{{ item.label }}</th>
                <td class="">
                  <div style="display: flex;justify-content: space-between">
                  <p style="text-align: right;width: 120px;">{{ formatThousands(item.valueCn) }} RMB</p>
                  <p style="color: #ff8726;width: 110px;text-align: right">{{ formatThousands(item.value) }} 円</p>
                  </div>
                </td>
              </tr>
            </table>

            <!-- 明细 -->
            <h3 class="section-title">{{ $t('saledFeedback.addTemplate12') }}</h3>
            </div>
            <table>
              <thead>
              <tr>
                <th class="col-img">{{ $t('BuddleOrder.BuddleOrder7') }}</th>
                <!-- <th class="col-img">{{ $t('saledFeedback.addTemplate13') }}</th> -->
                <th class="col-url">URL・{{ $t('saledFeedback.addTemplate14') }}</th>
                <th class="col-color">色</th>
                <th class="col-size">{{ $t('saledFeedback.addTemplate15') }}</th>
                <th class="col-total">{{ $t('OrderDetail.OrderDetail47') }}</th>
                <th class="col-inlandFreightRmb">{{ $t('OrderDetail.OrderDetail40') }}</th>
                <th class="col-remark">{{ $t('createOrder.createOrder128') }}</th>
                <th class="col-inspectionItems">{{ $t('OrderDetail.OrderDetail66') }}</th>
                <th class="col-inspectionFeeRmb">{{ $t('OrderDetail.OrderDetail38') }}</th>
                <th class="col-agentServiceFee">{{ $t('fund.agentServiceFee') }}</th>
                <th class="col-totalPrice">{{ $t('fund.totalPrice') }}</th>
                <th class="col-merchantRemark">{{ $t('saledFeedback.merchantRemark') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in info.orderList" :key="item.orderId">
                <td class="text-center">
                  {{ item.orderId }}
                  <img
                      :src="getImageSrc(item.pictureUrl)"
                      class="product-img"
                      crossorigin="anonymous"
                  />
                </td>
                <!-- <td class="text-center">
                  <img
                      :src="item.pictureUrl"
                      class="product-img"
                      crossorigin="anonymous"
                  />
                </td> -->
                <td>
                  <el-tooltip :content="item.goodName" placement="top" effect="light">
                    <p class="text-row-1">{{ item.goodName }}</p>
                  </el-tooltip>
                  <el-tooltip placement="top" effect="light">
                    <div slot="content"><p style="max-width: 400px">{{ item.goodsUrl }}</p></div>
                    <a class="text-row-1" :href="item.goodsUrl" target="_blank">{{ item.goodsUrl }}</a>
                  </el-tooltip>
                </td>
                <td class="text-center">
                  <el-tooltip :content="item.color" placement="top" effect="light">
                    <span class="text-row-2">{{ item.color }}</span>
                  </el-tooltip>
                </td>
                <td class="text-center">
                  <el-tooltip :content="item.goodsSize" placement="top" effect="light">
                    <span class="text-row-2">{{ item.goodsSize }}</span>
                  </el-tooltip>
                </td>
                <td class="text-center">
                  <p>{{ formatThousands(item.goodsPrice) }} * {{ item.goodsCount }}</p>
                  <p style="margin-top: 2px;">{{ formatThousands(item.totalPrice) }} RMB</p>
                </td>
                <td class="text-center">
                    <el-tooltip :content="item.inlandFreightRmb" placement="top" effect="light">
                        <p style="margin-top: 1px">{{ item.inlandFreightRmb?.toLocaleString() }} RMB</p>
                    </el-tooltip>
                </td>
                <td>
                  <el-tooltip placement="top" effect="light">
                    <div slot="content"><p style="max-width: 400px">{{ item.customerRemark }}</p></div>
                    <a class="text-row-2">{{ item.customerRemark }}</a>
                  </el-tooltip>
                </td>
                <td class="text-center inspection-items-cell">
                    <div style="white-space: pre-wrap;word-break: break-all;" v-for="(name, idx) in getInspectionNames(item).split('\n')" :key="idx" v-if="name">
                        {{ name }}
                    </div>
                </td>
                <td class="text-center">
                    <el-tooltip :content="item.inspectionPrice" placement="top" effect="light">
                        <p style="margin-top: 1px">{{ item.inspectionPrice?.toLocaleString() }} RMB</p>
                    </el-tooltip>
                </td>
                <td class="text-center">
                    <el-tooltip :content="item.agentServiceFee" placement="top" effect="light">
                        <p style="margin-top: 1px">{{ item.agentServiceFee?.toLocaleString() }} RMB</p>
                    </el-tooltip>
                </td>
                <td class="text-center">
                    <el-tooltip :content="item.priceRmb" placement="top" effect="light">
                        <p style="margin-top: 1px">{{ item.priceRmb?.toLocaleString() }} RMB</p>
                    </el-tooltip>
                </td>
                <td>
                  <el-tooltip placement="top" effect="light">
                    <div slot="content"><p style="max-width: 400px">{{ item.merchantRemark }}</p></div>
                    <a class="text-row-2">{{ item.merchantRemark }}</a>
                  </el-tooltip>
                </td>
              </tr>
              </tbody>
            </table>

            <!-- 备注 -->
            <div class="notes">
              <strong>{{ $t('saledFeedback.addTemplate16') }}</strong>
              <ul style="margin-left: 25px;">
                <li v-for="(note, index) in notes" :key="index">
                  <span v-if="note.prefix" style="display: inline-block; min-width: 140px">{{ note.prefix }}</span>
                  <span>{{ note.body || note }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div slot="footer" class="" style="display: flex;justify-content: flex-end;">
        <el-button class="cancel" @click="handleClose">{{ $t('saledFeedback.fanhui') }}</el-button>
        <el-button v-if="row.payStatus === '0'" class="cancel" @click="handleCancelPay">{{ $t('saledFeedback.cancelPay') }}</el-button>
        <el-button v-if="row.payStatus === '0'" class="form-btn btn-blue" @click="handlePayClick">{{ $t('fba.pay') }}</el-button>
      </div>
      <div v-if="isDownloading" class="pdf-export-mask">
        <i class="el-icon-loading"></i>
      </div>
    </el-dialog>
    <!-- 取消支付原因弹窗 -->
    <el-dialog :title="$t('saledFeedback.cancelPay')" :visible.sync="cancelDialogVisible" width="500px" :close-on-click-modal="false" append-to-body>
      <el-form :model="cancelForm" ref="cancelFormRef" :rules="cancelRules">
        <el-form-item :label="$t('saledFeedback.cancelReason')" prop="reason">
          <el-input type="textarea" v-model="cancelForm.reason" :rows="4" maxlength="100" show-word-limit :placeholder="$t('common.pleaseInput')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="handleCancelConfirm">{{ $t('confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import XLSX from 'xlsx-js-style'
import moment from 'moment'
import { formatThousands, dataTimeFn } from "@/assets/js/utils";

const PDF_PAGE_MARGIN = 10
const PDF_CAPTURE_SCALE = 2
const PDF_IMAGE_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAAAAACw='
const sleep = (time = 0) => new Promise(resolve => setTimeout(resolve, time))

export default {
  data () {
    return {
      formatThousands,
      dataTimeFn,
      invoiceDate: '2025年〇月〇日',
      sender: {
        company: '自社名・屋号',
        zip: '000-0000',
        address: '显示地址〇〇',
        tel: '03-0000-0000',
        contact: 'HAN SHIYONG',
      },
      summary: [
        { label: '商品金額', value: 0,valueCn: '0' },
        { label: '中国国内送料', value: 0,valueCn: '0' },
        { label: '代行手数料', value: 0,valueCn: '0' },
        { label: '検品手数料', value: 0,valueCn: '0' },
      ],

      items: [
        {
          orderNo: '45678',
          image: 'https://via.placeholder.com/60',
          name: 'Tシャツ 春夏用',
          url: 'https://item.taobao.com/...',
          color: '白',
          size: 'M',
          price: '1,000',
          qty: 50,
          total: '50,000',
          remark: '在庫少',
        },
        {
          orderNo: '45679',
          image: 'https://via.placeholder.com/60',
          name: 'デニムパンツ',
          url: 'https://detail.1688.com/...',
          color: '青',
          size: 'L',
          price: '2,500',
          qty: 20,
          total: '50,000',
          remark: '',
        },
      ],

      notes: [
        { prefix: '', body: this.$t('saledFeedback.remarkTemplate26') },
        { prefix: '', body: this.$t('saledFeedback.remarkTemplate27') },
        { prefix: '', body: this.$t('saledFeedback.remarkTemplate28') },
        { prefix: '', body: this.$t('saledFeedback.addTemplate29') },
      ],
      info: {},
      // configLists: {
      //   inspectionConfigList: []
      // },
      cancelDialogVisible: false,
      cancelForm: {
        reason: ''
      },
      isDownloading: false,
      cancelRules: {
        reason: [{ required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' }]
      }
    };
  },
  computed: {
    ...mapState(['exchangeRate']),
    paypalData() {
      const { moneyCn, moneyJp } = this.info;
      let data = {
        tradingNo: this.row.tradingNo,
        rechargeDto: {
          exchangeRate: this.exchangeRate,
          money: moneyCn,
          moneyJpy: moneyJp,
          rechargeType: '2',
        }, // 支付信息额外携带的参数
        clientType: '1',
        type: 'submit',
      };
      return data;
    }
  },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    onCancelPay: {
      type: Function,
      default: null
    },
    onPay: {
      type: Function,
      default: null
    },
  },
  created () {
    this.getrecordList();
    // this.getConfigLists();
  },
  methods: {
    getImageSrc (url) {
      if (!url || typeof url !== 'string') return url;

      try {
        const parsedUrl = new URL(url, window.location.origin);
        parsedUrl.pathname = parsedUrl.pathname
          .split('/')
          .map((segment) => {
            try {
              return encodeURIComponent(decodeURIComponent(segment));
            } catch (error) {
              return encodeURIComponent(segment);
            }
          })
          .join('/');

        return parsedUrl.href;
      } catch (error) {
        return encodeURI(url);
      }
    },
    async getrecordList () {
      const params = {billNo: this.row.tradingNo}
      const res = await this.$http.get('cmUser/capitalRecord/getQuoteBill', {params});
      // console.log(res.data,890);
      this.info = res.data.data;

      const summaryData = [
        { label: '商品金額', value: res.data.data.totalProductPriceJp || 0, valueCn: res.data.data.totalProductPriceCn || 0 },
        { label: '中国国内送料', value: res.data.data.inlandFreightJp || 0, valueCn: res.data.data.inlandFreightCn || 0 },
        { label: '代行手数料', value: res.data.data.agentServiceFeeJp || 0, valueCn: res.data.data.agentServiceFeeCn || 0 },
        { label: '検品手数料', value: res.data.data.totalInspectionPriceJp || 0, valueCn: res.data.data.totalInspectionPriceCn || 0 }
      ];

      // 统一与 zhangdan.vue 的手续费展示逻辑
      const purchaseConfigs = (res.data.data.purchaseAgentConfigs || []);
      let parsedConfigs = [];
      if (purchaseConfigs && purchaseConfigs.length > 0) {
        parsedConfigs = purchaseConfigs;
      } else {
        let configs = res.data.data.serviceCalculateFormula;
        if (configs) {
          if (typeof configs === 'string') {
            try {
              const parsed = JSON.parse(configs);
              if (parsed && parsed.serviceCalculateFormula && Array.isArray(parsed.serviceCalculateFormula)) {
                parsedConfigs = parsed.serviceCalculateFormula;
              } else if (Array.isArray(parsed)) {
                parsedConfigs = parsed;
              }
            } catch (e) {
              console.error("JSON parse error for serviceCalculateFormula", e);
            }
          } else if (typeof configs === 'object') {
            if (Array.isArray(configs)) {
              parsedConfigs = configs;
            } else if (configs.serviceCalculateFormula && Array.isArray(configs.serviceCalculateFormula)) {
              parsedConfigs = configs.serviceCalculateFormula;
            }
          }
        }
      }

      if (parsedConfigs.length > 0) {
        parsedConfigs.sort((a, b) => Number(a.startPrice || 0) - Number(b.startPrice || 0));
        const configNotes = parsedConfigs.map((cfg) => {
          const parts = [];
          if (cfg.includeItemCost) parts.push(this.$t('saledFeedback.itemCost'));
          if (cfg.includeDomesticFreight) parts.push(this.$t('saledFeedback.domesticFreight'));
          const content = parts.join('＋');

          let prefix = '';
          if (cfg.endPrice !== null && cfg.endPrice !== undefined) {
            prefix = this.$t('saledFeedback.priceRange', { start: Number(cfg.startPrice), end: Number(cfg.endPrice) });
          } else {
            prefix = this.$t('saledFeedback.priceRangeEndless', { start: Number(cfg.startPrice) });
          }

          let body = '';
          const fixedFee = Number(cfg.fixedFee) || 0;

          if (parts.length === 0 || Number(cfg.serviceRate) === 0) {
            const startLabel = this.$t('saledFeedback.formulaStart').replace(/按?[（(]/, '');
            body = `${startLabel} ${fixedFee}元`;
          } else {
            let start = this.$t('saledFeedback.formulaStart');
            let middle = this.$t('saledFeedback.formulaMiddle', { rate: cfg.serviceRate });

            if (parts.length === 1) {
              start = start.replace(/[（(]/, ' ');
              middle = middle.replace(/[）)]/, ' ');
            }

            body = `${start}${content}${middle}`;
            if (fixedFee > 0) {
              body += this.$t('saledFeedback.formulaFixed', { fee: fixedFee });
            }
            body += this.$t('saledFeedback.formulaEnd');
          }
          return { prefix, body };
        });

        const newNotes = [
          { prefix: '', body: this.$t('saledFeedback.remarkTemplate26', { rate: res.data.data.exchangeRate }) },
          { prefix: '', body: this.$t('saledFeedback.remarkTemplate27') },
          ...configNotes,
          { prefix: '', body: this.$t('saledFeedback.addTemplate29') },
        ];
        this.notes = newNotes;
      } else {
        this.notes = [
          { prefix: '', body: this.$t('saledFeedback.remarkTemplate26', { rate: res.data.data.exchangeRate }) },
          { prefix: '', body: this.$t('saledFeedback.remarkTemplate27') },
          { prefix: '', body: this.$t('saledFeedback.remarkTemplate28', { rate: res.data.data.serviceRate }) },
          { prefix: '', body: this.$t('saledFeedback.addTemplate29') },
        ];
      }

      this.summary = summaryData;
      // this.notes[0] = `上記金額は、1元＝${res.data.data.exchangeRate}円（レート）にて換算しております。`;
    },
    // 获取检品项配置
    async getConfigLists() {
      const { data: res } = await this.$http.get(
          "order/getOrderInfoConfigList"
      );
      this.configLists = res.data;
      //如果客户拥有特殊检品选项，则查询合并
      // const { data: res2 } = await this.$http.get(
      //     "customsDeclaration/getInspectOption",
      //     {
      //       params: {
      //         customerId: this.row.customerId,
      //       },
      //     }
      // );
      if (res2.data != null && res2.data.length > 0) {
        let inspectionConfigList = res2.data.map((item) => {
          return {
            name: item.name,
            value: item.nameCd,
          };
        });
        this.configLists.inspectionConfigList =
            this.configLists.inspectionConfigList.concat(inspectionConfigList);
      }
    },
    // 将检品项编码转换为名称
    getInspectionNames(data) {
      const { configCheckProjectArray } = data;
      if (!configCheckProjectArray) return '';
      const codes = typeof configCheckProjectArray === 'string'
          ? configCheckProjectArray.split(',').filter(Boolean)
          : configCheckProjectArray;

      if (!codes || codes.length === 0) return '';
      const mapValue = this.info.checkNameMap;
      const names = codes.map(code => {
        return mapValue[code]
        // const item = this.configLists.inspectionConfigList.find(c => c.value === code);
        // return item ? item.name : code;
      }).filter(Boolean);

      return names.join('\n');
    },
    handleClose () {
      this.$options.cancel('cancel')
    },
    handleCancelPay () {
      this.cancelForm.reason = ''
      this.cancelDialogVisible = true
    },
    handleCancelConfirm () {
      this.$refs.cancelFormRef.validate((valid) => {
        if (valid) {
          if (this.onCancelPay) {
            this.onCancelPay(this.row, this.cancelForm.reason)
          }
          this.cancelDialogVisible = false
          this.handleClose()
        }
      })
    },
    handlePayClick() {
      if (this.onPay) {
        this.onPay(this.paypalData, () => {
          this.handleClose();
        });
        return;
      }
      this.$message.error('Missing onPay');
    },
    downloadExcel() {
      // --- 样式定义 ---
      const borderStyle = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" }
      };
      
      const commonStyle = {
        font: { name: "Arial", sz: 11 },
        alignment: { vertical: "center", wrapText: true }
      };

      const titleStyle = {
        font: { name: "Arial", sz: 18, bold: true },
        alignment: { horizontal: "center", vertical: "center" }
      };

      const labelStyle = {
        font: { name: "Arial", sz: 11, bold: true },
        alignment: { vertical: "center", horizontal: "right", wrapText: true }
      };

      const labelStylelt = {
        font: { name: "Arial", sz: 11, bold: true },
        alignment: { vertical: "center", horizontal: "left", wrapText: true }
      };

      const valueStyle = {
        font: { name: "Arial", sz: 11 },
        alignment: { vertical: "center", horizontal: "left" }
      };

      const totalAmountStyle = {
        font: { name: "Arial", sz: 14, bold: false },
        alignment: { vertical: "center", horizontal: "left" }
      };

      const totalAmountRedStyle = {
        font: { name: "Arial", sz: 14, bold: false, color: { rgb: "FF0000" } }, // 红色不加粗
        alignment: { vertical: "center", horizontal: "left" }
      };

      const tableHeaderStyle = {
        font: { name: "Arial", sz: 11, bold: true },
        fill: { fgColor: { rgb: "E9E9E9" } }, // 浅灰背景
        border: borderStyle,
        alignment: { horizontal: "center", vertical: "center", wrapText: true }
      };

      const tableCellStyle = {
        font: { name: "Arial", sz: 10 },
        border: borderStyle,
        alignment: { vertical: "center", wrapText: true }
      };
      
      const tableCellRedStyle = {
        font: { name: "Arial", sz: 10, color: { rgb: "FF0000" } },
        border: borderStyle,
        alignment: { vertical: "center", horizontal: "center", wrapText: true }
      };

      const tableCellCenterStyle = {
        ...tableCellStyle,
        alignment: { vertical: "center", horizontal: "center", wrapText: true }
      };

      const tableCellLeftStyle = {
        ...tableCellStyle,
        alignment: { vertical: "center", horizontal: "left", wrapText: true }
      };

      const tableCellRedLeftStyle = {
        font: { name: "Arial", sz: 10, color: { rgb: "FF0000" } },
        border: borderStyle,
        alignment: { vertical: "center", horizontal: "left", wrapText: true }
      };

      const tableCellRightStyle = {
        ...tableCellStyle,
        alignment: { vertical: "center", horizontal: "right", wrapText: true }
      };

      const notesTextStyle = {
        font: { name: "Arial", sz: 10 },
        alignment: { vertical: "center", horizontal: "left", wrapText: true }
      };

      // --- 数据准备 ---
      
      // 1. 标题行
      const wsData = [
        ['御 見 積 書'],
        [],
      ];

      // 2. 基本信息
      // 构建数据行
      const goodName = (this.info.orderList && this.info.orderList[0]) ? this.info.orderList[0].goodName : '';

      const row3 = this.info.billTopic ? ['件名：', this.info.billTopic, '', '見積No：', this.info.tradingNo] : ['', '', '', '見積No：', this.info.tradingNo]
      
      const basicInfoRows = [
        // Row 2: 客户名
        [this.info.userName + ' 様 御中'], 
        // Row 3: 日期
        ['', '', '', '見積日：', this.dataTimeFn(this.info.sendBillDate)],
        // Row 4: 件名 & No
        row3,
        // Row 5: 发行元
        ['', '', '', '【発行元】：', this.info.companyName],
        // Row 6: 邮编
        ['', '', '', '〒：', this.info.postCode],
        // Row 7: 地址
        ['', '', '', '住所：', this.info.address],
        // Row 8: 电话
        ['', '', '', 'TEL：', this.info.contactPhone],
        // Row 9: 担当
        ['', '', '', '担当：', this.info.contactPerson],
      ];
      wsData.push(...basicInfoRows);
      wsData.push([]); // Row 10 空行

      // 3. 总金额 (Row 11)
      wsData.push([this.$t('saledFeedback.addTemplate10'), `${this.formatThousands(this.info.moneyCn)} RMB`, `${this.formatThousands(this.info.moneyJp)} 円`]);
      wsData.push([]); // Row 12 空行

      // 4. 汇总表格 (Row 12+)
      const summaryStartRow = wsData.length;
      wsData.push(['', '金額(RMB)', '金額(円)']); // Header
      this.summary.forEach(item => {
        wsData.push([
          item.label,
          this.formatThousands(item.valueCn),
          this.formatThousands(item.value)
        ]);
      });
      wsData.push([]); // 空行

      // 5. 明细表格 (Row 16+)
      const detailsStartRow = wsData.length;
      wsData.push([
        this.$t('BuddleOrder.BuddleOrder7'), // 订单号
        this.$t('saledFeedback.addTemplate13'), // 图片
        this.$t('saledFeedback.addTemplate14'), // 商品名
        'URL', // 链接
        '色',
        this.$t('saledFeedback.addTemplate15'), // 尺码
        '単価(RMB)', // 单价
        '数量', // 数量
        `${this.$t('OrderDetail.OrderDetail40')}(RMB)`, // 国内运费
        this.$t('createOrder.createOrder128'), // 备注
        this.$t('OrderDetail.OrderDetail66'), // 检品项
        `${this.$t('OrderDetail.OrderDetail38')}(RMB)`, // 检品手数料
        `${this.$t('fund.agentServiceFee')}(RMB)`, // 代行手数料
        `${this.$t('fund.totalPrice')}(RMB)`, // 总计金额
        this.$t('saledFeedback.merchantRemark'), // 商品备注
      ]);

      const orderList = this.info.orderList || [];
      orderList.forEach(item => {
        wsData.push([
          item.orderId,
          item.pictureUrl,
          item.goodName,
          item.goodsUrl,
          item.color,
          item.goodsSize,
          this.formatThousands(item.goodsPrice ?? 0),
          item.goodsCount ?? 0,
          this.formatThousands(item.inlandFreightRmb ?? 0),
          item.customerRemark,
          this.getInspectionNames(item),
          this.formatThousands(item.inspectionPrice ?? 0),
          this.formatThousands(item.agentServiceFee ?? 0),
          this.formatThousands(item.priceRmb ?? 0),
          item.merchantRemark ?? ''
        ]);
      });
      if (orderList.length === 0) {
        wsData.push(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);
      }

      // 6. 备注区域
      wsData.push([]);
      const notesHeaderRow = wsData.length;
      wsData.push([this.$t('saledFeedback.addTemplate16')]);
      const notesStartRow = wsData.length;
      const notesList = this.notes || [];
      notesList.forEach(n => {
        const isObj = n && typeof n === 'object';
        const prefix = isObj ? (n.prefix || '') : '';
        const body = isObj ? (n.body || '') : (n || '');
        const text = [prefix, body].filter(Boolean).join(' ');
        wsData.push(['・ ' + text, '', '', '']);
      });

      // --- 生成 Sheet ---
      const ws = XLSX.utils.aoa_to_sheet(wsData);

      // --- 应用样式 ---
      const range = XLSX.utils.decode_range(ws['!ref']);

      // 1. 设置列宽
      ws['!cols'] = [
        { wch: 13 }, // A
        { wch: 35 }, // B
        { wch: 30 }, // C
        { wch: 17 }, // D
        { wch: 30 }, // E
        { wch: 10 }, // F
        { wch: 12 }, // G
        { wch: 8 },  // H
        { wch: 12 }, // I
        { wch: 18 }, // J - 检品项
        { wch: 12 }, // K
        { wch: 25 }, // L
        { wch: 16 }, // M
        { wch: 14 }, // N
        { wch: 14 }, // O - 商品备注
      ];

      // 2. 遍历单元格应用样式
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) {
            // 仅为“明细表格”区域创建空单元格，避免影响汇总表格
            if (R >= detailsStartRow && R < notesHeaderRow) {
              ws[cellRef] = { t: 's', v: '' };
            } else {
              continue;
            }
          }

          // 默认样式
          ws[cellRef].s = commonStyle;
          
          // 标题行 (Row 0)
          if (R === 0) {
            ws[cellRef].s = titleStyle;
          }
          
          // 基本信息区域 (Row 2-9)
          else if (R >= 2 && R <= 9) {
            // Row 2: 客户名 (A列)
            if (R === 2 && C === 0) {
              ws[cellRef].s = { 
                font: { name: "Arial", sz: 12, bold: true },
                alignment: { vertical: "center", horizontal: "left" }
              };
            }
            // Row 4: 件名 (A列 Label, B列 Value)
            else if (R === 4 && C === 0) {
               ws[cellRef].s = { ...labelStyle, alignment: { vertical: "top", horizontal: "left" } };
            }
            else if (R === 4 && C === 1) { // 件名内容
               ws[cellRef].s = { ...valueStyle, alignment: { vertical: "top", horizontal: "left", wrapText: true } };
            }
            // 右侧信息 (D列 Label, E列 Value)
            else if (C === 3) { // D列
               ws[cellRef].s = { ...labelStyle, alignment: { vertical: "center", horizontal: "left" } };
            }
            else if (C === 4) { // E列 (合并后的Value)
               ws[cellRef].s = { ...valueStyle, alignment: { vertical: "center", horizontal: "right" } };
            }
          }

          // 总金额行 (Row 11)
          else if (R === 11) {
            if (C === 0) ws[cellRef].s = labelStylelt;
            else if (C === 2) ws[cellRef].s = totalAmountRedStyle; // 日元红色
            else ws[cellRef].s = totalAmountStyle; // 其他(RMB)默认黑色
          }

          // 汇总表格 (Summary)
          else if (R >= summaryStartRow && R < detailsStartRow - 1) {
            if (R === summaryStartRow) {
               // Summary Header
               ws[cellRef].s = tableHeaderStyle;
            } else {
               // Summary Body
               // 日元列 (E列, index 2) 设置为红色
               if (C === 2) {
                 ws[cellRef].s = tableCellRedLeftStyle;
               } else {
                 ws[cellRef].s = tableCellLeftStyle;
               }
            }
          }

          // 明细表格 (Details)
          else if (R >= detailsStartRow && R < notesHeaderRow - 1) {
            if (R === detailsStartRow) {
              // Details Header
              ws[cellRef].s = tableHeaderStyle;
            } else {
              // Details Body
              let style = tableCellCenterStyle;
              
              // 商品名(C列)、URL(D列)、备注(N列)、商品备注(O列) 左对齐
              if (C === 2 || C === 3 || C === 13 || C === 14) style = tableCellLeftStyle;
              // 金额列 (G, I, J, K, L) 右对齐；数量(H) 保持居中
              if ([6, 8, 9, 10, 11].includes(C)) style = tableCellRightStyle;

              ws[cellRef].s = style;
            }
          }

          // 备注标题
          else if (R === notesHeaderRow) {
            if (C === 0) {
              ws[cellRef].s = {
                font: { name: "Arial", sz: 12, bold: true },
                alignment: { vertical: "center", horizontal: "left" }
              };
            } else {
              ws[cellRef].s = commonStyle;
            }
          }

          // 备注内容
          else if (R >= notesStartRow) {
            if (C === 0 || C === 1 || C === 2 || C === 3) {
              ws[cellRef].s = notesTextStyle;
            } else {
              // 备注仅使用前四列，其余保持默认
              ws[cellRef].s = commonStyle;
            }
          }
        }
      }

      // --- 合并单元格 ---
      const merges = [
        // 标题合并 (A1:O1)
        { s: { r: 0, c: 0 }, e: { r: 0, c: 14 } },
      ];
      // 备注内容合并 (每行合并 A、B、C、D 列)
      const notesCount = notesList.length;
      for (let i = 0; i < notesCount; i++) {
        const r = notesStartRow + i;
        merges.push({ s: { r, c: 0 }, e: { r, c: 3 } });
      }
      ws['!merges'] = merges;

      // 3. 导出
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "御見積書");
      XLSX.writeFile(wb, `御見積書_${this.info.tradingNo}.xlsx`);
    },
    getPdfCanvasOptions() {
      return {
        scale: PDF_CAPTURE_SCALE,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#fff',
        imageTimeout: 8000,
        scrollX: 0,
        scrollY: -window.scrollY,
        onclone: (documentClone) => {
          documentClone.querySelectorAll('.product-img').forEach((img) => {
            img.crossOrigin = 'anonymous'
            img.onerror = () => {
              img.src = PDF_IMAGE_PLACEHOLDER
            }
            if (img.complete && img.naturalWidth === 0) {
              img.src = PDF_IMAGE_PLACEHOLDER
            }
          })
        }
      }
    },
    preparePdfElement(element) {
      const hideEls = element.querySelectorAll('.no-print')
      hideEls.forEach(el => {
        el.__originDisplay = el.style.display
        el.style.display = 'none'
      })

      const rowEls = element.querySelectorAll('.text-row-1, .text-row-2, .text-row-3')
      rowEls.forEach(el => {
        el.__originClass = el.className
        el.classList.remove('text-row-1', 'text-row-2', 'text-row-3')
      })

      element.classList.add('pdf-export')

      return () => {
        rowEls.forEach(el => {
          el.className = el.__originClass
          delete el.__originClass
        })

        hideEls.forEach(el => {
          el.style.display = el.__originDisplay || ''
          delete el.__originDisplay
        })

        element.classList.remove('pdf-export')
      }
    },
    async exportByPagedCanvas(element) {
      const pdf = new jsPDF('p', 'mm', 'a4')
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()
      const pdfWidth = pageWidth - PDF_PAGE_MARGIN * 2
      const pdfHeight = pageHeight - PDF_PAGE_MARGIN * 2
      const elementWidth = Math.max(1, Math.ceil(element.scrollWidth || element.getBoundingClientRect().width))
      const elementHeight = Math.max(1, Math.ceil(element.scrollHeight || element.getBoundingClientRect().height))
      const pageHeightPx = Math.max(1, Math.floor((pdfHeight * elementWidth) / pdfWidth))
      const contentElement = element.firstElementChild || element
      const elementStyles = {
        position: element.style.position,
        width: element.style.width,
        height: element.style.height,
        overflow: element.style.overflow,
        background: element.style.background
      }
      const contentStyles = contentElement === element ? null : {
        transform: contentElement.style.transform,
        transformOrigin: contentElement.style.transformOrigin,
        width: contentElement.style.width,
        maxWidth: contentElement.style.maxWidth
      }

      let offsetTop = 0
      let pageIndex = 0

      try {
        element.style.position = 'relative'
        element.style.width = `${elementWidth}px`
        element.style.overflow = 'hidden'
        element.style.background = '#ffffff'

        while (offsetTop < elementHeight) {
          const currentPageHeight = Math.min(pageHeightPx, elementHeight - offsetTop)
          element.style.height = `${currentPageHeight}px`
          if (contentElement !== element) {
            contentElement.style.transform = `translateY(-${offsetTop}px)`
            contentElement.style.transformOrigin = 'top left'
            contentElement.style.width = `${elementWidth}px`
            contentElement.style.maxWidth = 'none'
          }

          await sleep(50)
          const canvas = await html2canvas(element, {
            ...this.getPdfCanvasOptions(),
            width: elementWidth,
            height: currentPageHeight,
            windowWidth: elementWidth,
            windowHeight: currentPageHeight
          })
          const imgData = canvas.toDataURL('image/png', 1.0)
          const pdfImageHeight = (currentPageHeight * pdfWidth) / elementWidth

          if (pageIndex > 0) pdf.addPage()
          pdf.addImage(imgData, 'PNG', PDF_PAGE_MARGIN, PDF_PAGE_MARGIN, pdfWidth, pdfImageHeight)

          offsetTop += currentPageHeight
          pageIndex++
        }
      } finally {
        element.style.position = elementStyles.position
        element.style.width = elementStyles.width
        element.style.height = elementStyles.height
        element.style.overflow = elementStyles.overflow
        element.style.background = elementStyles.background
        if (contentStyles) {
          contentElement.style.transform = contentStyles.transform
          contentElement.style.transformOrigin = contentStyles.transformOrigin
          contentElement.style.width = contentStyles.width
          contentElement.style.maxWidth = contentStyles.maxWidth
        }
      }

      return pdf
    },
    async exportBySingleCanvas(element) {
      const canvas = await html2canvas(element, this.getPdfCanvasOptions())
      const pdf = new jsPDF('p', 'mm', 'a4')
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()
      const pdfWidth = pageWidth - PDF_PAGE_MARGIN * 2
      const pdfPageHeightPx = ((pageHeight - PDF_PAGE_MARGIN * 2) * canvas.width) / pdfWidth

      let renderedHeight = 0
      let pageIndex = 0

      while (renderedHeight < canvas.height) {
        const pageCanvas = document.createElement('canvas')
        const ctx = pageCanvas.getContext('2d')
        pageCanvas.width = canvas.width
        pageCanvas.height = Math.min(pdfPageHeightPx, canvas.height - renderedHeight)
        ctx.drawImage(canvas, 0, renderedHeight, canvas.width, pageCanvas.height, 0, 0, canvas.width, pageCanvas.height)

        const imgData = pageCanvas.toDataURL('image/png', 1.0)

        if (pageIndex > 0) pdf.addPage()
        pdf.addImage(imgData, 'PNG', PDF_PAGE_MARGIN, PDF_PAGE_MARGIN, pdfWidth, (pageCanvas.height * pdfWidth) / canvas.width)

        renderedHeight += pageCanvas.height
        pageIndex++
      }

      return pdf
    },
    async downloadPdf() {
      if (this.isDownloading) return
      const tradingNo = this.info.tradingNo
      if (!tradingNo) {
        this.$message && this.$message.error('缺少报价单编号信息')
        return
      }

      this.isDownloading = true
      try {
        const res = await this.$http.get('order/exportQuoteBillPdf', {
          params: { tradingNo },
          responseType: 'blob',
        })
        const blob = new Blob([res.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `御見積書_${tradingNo}.pdf`
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error(error)
        this.$message && this.$message.error('PDF 导出失败')
      } finally {
        this.isDownloading = false
      }
    },
    formatText(text) {
      if (!text) return ''
      let res = ''
      for (let i = 0; i < text.length; i += 15) {
        res += text.substring(i, i + 15) + '<br/>'
      }
      if (res.endsWith('<br/>')) {
        res = res.substring(0, res.length - 5)
      }
      return res
    }
  },

};
</script>

<style lang="less" scoped>
.summary-table{
  th{
    text-align: right;
  }
}
/* A4サイズ風のコンテナ */
.invoice-box {
  // max-width: 1060px;
  margin: auto;
  background: #fff;
  padding: 30px 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}

/* ヘッダー周り */
.header-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  border-bottom: 2px solid #333;
  display: inline-block;
  margin-bottom: 20px;
  padding-bottom: 5px;
}
.client-info {
  font-size: 18px;
  font-weight: bold;
}
.sender-info {
  text-align: right;
  font-size: 14px;
  line-height: 1.6;
  margin-right: 10px;
  position: relative;
  min-width: 200px;
  text-align: left;
}

/* 請求金額の表示エリア */
.grand-total-box {
  text-align: center;
  background-color: #eef;
  padding: 15px;
  border: 2px solid #333;
}
.grand-total-box h2 {
  margin: 0;
  font-size: 18px;
}
.grand-total-box .price {
  font-size: 32px;
  font-weight: bold;
}
.section-title{
  font-size: 16px;
  border-left: 5px solid #333;
  padding-left: 10px;
  margin-bottom: 20px;
}
/* テーブル共通スタイル */
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
th, td {
  padding: 10px;
  border: 1px solid #ddd;
  vertical-align: middle;
  font-size: 14px;
}
th {
  background-color: #f2f2f2;
  font-weight: bold;
  text-align: center;
}

/* 列の幅調整 */
.col-img { width: 90px; }
.col-url { min-width: 150px; }
.col-color { width: 60px; }
.col-size { width: 70px; }
.col-price { width: 60px; }
.col-qty { width: 50px; }
.col-total { width: 120px; }
.col-inlandFreightRmb { width: 90px; }
.col-inspectionItems { width: 120px; }
.col-inspectionFeeRmb { width: 90px; }
.col-agentServiceFee { width: 100px; }
.col-totalPrice { width: 90px; }
.col-remark { min-width: 100px; }
.col-merchantRemark { min-width: 100px; }

.inspection-items-cell {
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
}

/* 金额等は右寄せ */
.text-right { text-align: right; }
.text-center { text-align: center; }

/* 商品画像のスタイル */
.product-img {
  width: 60px;
  height: 40px;
  object-fit: cover;
  border: 1px solid #eee;
}

/* リンクのスタイル */
a {
  color: #0066cc;
  text-decoration: none;
  word-break: break-all;
  font-size: 12px;
}

/* 備考エリア */
.notes {
  margin-top: 40px;
  font-size: 12px;
  border-top: 1px solid #ccc;
  padding-top: 10px;
}

/* 印刷設定 */
@media print {
  body { background: none; padding: 0; }
  .invoice-box { box-shadow: none; padding: 0; max-width: 100%; }
  .no-print { display: none; }
}

.pdf-export-mask {
  position: absolute;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.72);
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.pdf-export {
  background: #fff !important;
  color: #000 !important;
  .no-print {
    display: none !important;
  }
  .text-row-1,
  .text-row-2,
  .text-row-3 {
    display: block !important;
    -webkit-line-clamp: unset !important;
    line-clamp: unset !important;
    -webkit-box-orient: unset !important;
    overflow: visible !important;
    text-overflow: unset !important;
  }
}

.ErrorList{
  :deep(.el-dialog){
    border-radius: 20px;
    margin: 0 !important; /* 重置默认的 margin */
    position: absolute; /* 使用绝对定位 */
    top: 50%; /* 距离顶部50% */
    left: 50%; /* 距离左边50% */
    transform: translate(-50%, -50%); /* 偏移自身宽高的50% */
    min-width: 1100px;
  }
  :deep(.el-dialog__body){
    position: relative;
    padding: 0 20px;
  }
  :deep(.el-dialog__header){
    padding: 8px 20px;
    text-align: center;
    //background: linear-gradient(to bottom, #ff7e79, #7876a3);
    //background: linear-gradient(to bottom, rgb(2,125,180), #9ed6ef);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
}
.subject{
  max-width: 400px;
  display: flex;
  margin-top: 10px;
}

.subject-text {
  max-width: 80%;
  margin-top: 0;
}
.ck{
  color: #ff0000;
  margin-bottom: 30px;
  width: 100%;
  text-align: right;
}
.cancel{
  margin-right: 10px;
}
.cancel:hover{
  color: #409eff;
}
.formula-note {
  display: flex;
  margin-bottom: 5px;
  /* 确保列表项的标记（小圆点）可见 */
  display: list-item; 
  /* 使用 flex 布局可能会破坏 list-item 的显示，所以这里我们用内部元素来模拟 flex 效果，或者使用 float/inline-block */
  /* 为了保持小圆点，我们改回 display: list-item，并在内部使用 inline-block 或 float 来对齐 */
}
.note-wrapper {
    display: flex;
}
.note-range {
  display: inline-block;
  min-width: 180px; /* 根据实际需要调整宽度，确保对齐 */
  margin-right: 10px;
}
.note-content {
  display: inline-block;
}
</style>
